import {useEffect, useState, useRef} from 'react'
import {KTIcon} from '../../../_metronic/helpers'
import {ImportTracking} from './ImportTracking'
import axios from 'axios'
import Loader from 'react-js-loader'
import {ToastContainer} from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import {
  showToastMessageSuccess,
  showToastMessageError,
  showToastMessageWarning,
} from '../../modules/Toast-Message/TosatMessage'
import {useLocation} from 'react-router-dom'
import {DataTable} from 'primereact/datatable'
import {Column} from 'primereact/column'
import {Button} from 'primereact/button'
import { DataView } from 'primereact/dataview';
import { Card } from 'primereact/card';
import MobileUse from '../../modules/mobileUtilities/MobileUse'
import {CSVLink} from 'react-csv'
import { KTSVG } from '../../../_metronic/helpers'
import { Modal } from 'bootstrap'

const AUTH_LOCAL_STORAGE_KEY = 'kt-auth-react-v'

const getLocalData = () => {
  const data = localStorage.getItem(AUTH_LOCAL_STORAGE_KEY)
  return JSON.parse(data)
}

const TrackingManagement = () => {
  const location = useLocation()
  const search_state = location.state

  const [showCreateAppModal, setShowCreateAppModal] = useState(false)
  const [trackingData, setTrackingData] = useState([])
  const [loading, setLoading] = useState(false)
  const [btnLoading, setBtnLoading] = useState(false)
  const [deleteLoading, setDeleteLoading] = useState(false)
  const [checkBox, setCheckBox] = useState([])
  const [editId, setEditId] = useState(null)
  const [updatedOtp, setUpdatedOtp] = useState('')
  const [errorMsg, setErrorMsg] = useState('')
  const [showDeleteBtn, setShowDeleteBtn] = useState(false)

  const [refreshComm, setRefreshComm] = useState(false)

  const [toggleFilter, setToggleFilter] = useState('NONE')
  const [isOpen, setIsOpen] = useState(false)
  const [startDate, setStartDate] = useState('')
  const [endDate, setEndDate] = useState('')
  const [searchCommitID, setSearchCommitID] = useState('')
  const [searchDealID, setSearchDealID] = useState('')
  const [searchItemName, setSearchItemName] = useState('')
  const [searchTrackingNumber, setSearchTrackingNumber] = useState('')
  const [searchQuery, setSearchQuery] = useState('')
 
  const modalRef = useRef();
  const [title, setTitle] = useState("") 
  const [serial, setSerial] = useState([])
  const [GCQty, setGCQty] = useState(0);
  const [trackingStatus, setTrackingStatus] = useState(0);
  const [trackingItemId, setTrackingItemId] = useState();
  const [giftCardCodes,setGiftCardCodes] = useState([]);
  const [GCDeal,setGCDeal] = useState(false);
  const [extraData,setExtraData] = useState('');
  const [extraDataDeal,setExtraDataDeal] = useState(false);
  const [extraDataTrackingCode,setExtraDataTrackingCode] = useState();

  const [statusFilter, setStatusFilter] = useState(1)
  const [daysFilter, setDaysFilter] = useState('15')

  const isMobileDevice = MobileUse();
  const data = trackingData

  const handleSingleSearch = (value) => {
    setSearchQuery(value)
    setSearchCommitID(value)
    setSearchDealID(value)
    // setSearchItemName(value)
    setSearchTrackingNumber(value)
  }

  const cancleSearch = () => {
    setSearchCommitID('')
    setSearchDealID('')
    // setSearchItemName('')
    setStartDate('')
    setEndDate('')
    setSearchTrackingNumber('')
    setSearchQuery('')
  }

  const startDateObject = new Date(startDate)
  const endDateObject = new Date(endDate)

  const handleFilter = () => {
    if (startDate !== '' && endDate !== '') {
      const filteredItems = trackingData.filter(
        (item) =>
          item.commitment_no.toLowerCase().includes(searchCommitID.toLowerCase()) &&
          item.deal_no.toLowerCase().includes(searchDealID.toLowerCase()) &&
          // item.deal_name.toLowerCase().includes(searchItemName.toLowerCase()) &&
          item.tracking_id.toLowerCase().includes(searchTrackingNumber.toLowerCase()) &&
          new Date(item.created_date) >= startDateObject &&
          new Date(item.created_date) <= endDateObject
      )
      return filteredItems
    } else {
      const filteredItems = trackingData.filter(
        (item) =>
          item.commitment_no?.toLowerCase().includes(searchCommitID.toLowerCase()) ||
          item.deal_no?.toLowerCase().includes(searchDealID.toLowerCase()) ||
          // item.deal_name?.toLowerCase().includes(searchItemName.toLowerCase()) ||
          item.tracking_id?.toLowerCase().includes(searchTrackingNumber.toLowerCase())
      )
      return filteredItems
    }
  }

  // useEffect(() => {
  //   if (direct_open_state == 'OPEN_IMPORT_MODAL') {
  //     setShowCreateAppModal(true)
  //   }
  // }, [direct_open_state])
  useEffect(() => {
    if (search_state?.id && search_state?.query) {
      setSearchQuery(search_state?.query)
      handleSingleSearch(search_state?.query)
      setToggleFilter('SEARCH')
    }
  }, [search_state])

  const apiToken = getLocalData().api_token
  const API_URL = process.env.REACT_APP_API_URL
  const GET_TRACK_COMMIT = `${API_URL}/trackCommit`
  const DELETE_TRACK_COMMIT = `${API_URL}/user/trackingOrder/delete`
  const UPDATE_OTP_URL = `${API_URL}/user/update-OTP`
  const UPDATE_GIFTCARD_CODES = `${API_URL}/user/update-giftcard-codes`
  const UPDATE_EXTRADATA = `${API_URL}/user/update-extradata`

  const getTrackingCommit = async (statusFilterData,daysFilterData) => {
    setLoading(true)
    const config = {
      headers: {Authorization: `Bearer ${apiToken}`},
      params: {
          status_filter: statusFilterData,
          days_filter: daysFilterData,
        },
    }
    await axios
      .get(GET_TRACK_COMMIT, config)
      .then((response) => {
        setTrackingData(response.data.data)
        setLoading(false)
      })
      .catch((error) => {
        console.error(error)
        setLoading(false)
      })
  }

  const handleCheckChange = (e, index, val) => {
    const {checked} = e.target
    setCheckBox((prevCheckBox) => {
      const updatedCheckBox = [...prevCheckBox]
      updatedCheckBox[index] = {
        ...updatedCheckBox[index],
        check: checked,
        value: val,
      }
      return updatedCheckBox
    })
  }

  const deleteTrack = async () => {
    const getCheck = checkBox.filter((vall) => {
      return vall.check === true
    })
    const deletedIds = getCheck.map((val) => {
      return val.value.tracking_item_code
    })
    if (deletedIds.length === 0) {
      showToastMessageWarning('Please select a Track to delete')
    } else {
      setDeleteLoading(true)
      await axios
        .post(DELETE_TRACK_COMMIT, {
          id: deletedIds,
        })
        .then((response) => {
          showToastMessageSuccess(response.data.message)
          getTrackingCommit(statusFilter, daysFilter)
          setRefreshComm(true)
          setDeleteLoading(false)
        })
        .catch((error) => {
          console.error(error)
          showToastMessageError(error.message)
          setDeleteLoading(false)
        })
    }
  }

  const updateOTP = async () => {
    const data = {
      tracking_item_code: editId,
      otp: updatedOtp,
    }
    if (editId) {
      if (!updatedOtp) {
        setErrorMsg('enter otp*')
      } else if (updatedOtp.toString().length < 4) {
        setErrorMsg('minimum 4 digits*')
      } else if (updatedOtp.toString().length > 6) {
        setErrorMsg('maximum 6 digits*')
      } else {
        setBtnLoading(true)
        setErrorMsg('')
        await axios
          .post(UPDATE_OTP_URL, {
            otp: data,
          })
          .then((response) => {
            showToastMessageSuccess(response.data.message)
            getTrackingCommit(statusFilter, daysFilter)
            setBtnLoading(false)
          })
          .catch((error) => {
            console.error(error)
            showToastMessageError(error.message)
            setBtnLoading(false)
          })
        setEditId(null)
      }
    }
  }

  const handleGCInputChange = (index, value, serial_id) => {
    const updatedCodes = [...giftCardCodes];
    updatedCodes[index] = {
      serial_id: serial_id,
      tracking_item_id: trackingItemId,
      code: value,
    };
    setGiftCardCodes(updatedCodes);
  };


  const handleGCCodesSubmit = async ()=>{
    await axios.post(UPDATE_GIFTCARD_CODES, {
        codes: giftCardCodes,
      })
      .then((response) => {
        showToastMessageSuccess(response.data.message)
        getTrackingCommit(statusFilter, daysFilter)
        // setBtnLoading(false)
        const modalInstance = Modal.getInstance(modalRef.current);
        modalInstance.hide();
      })
      .catch((error) => {
        console.error(error)
        showToastMessageError(error.message)
        // setBtnLoading(false)
      })

    // console.log('Codes',giftCardCodes)
  }

  const handlExtraDataSubmit = async (trackingId)=>{
    await axios.post(UPDATE_EXTRADATA, {
        extradata: extraData,
        tracking_code:trackingId
      })
      .then((response) => {
        if(response.data.success == true){
          showToastMessageSuccess('Order Number Updated.')
        }else{
          showToastMessageSuccess('Something Went Wrong!')
        }
        getTrackingCommit(statusFilter, daysFilter)
        // const modalInstance = Modal.getInstance(modalRef.current);
        // modalInstance.hide();
      })
      .catch((error) => {
        console.error(error)
        showToastMessageError(error.message)
        // setBtnLoading(false)
      })

    // console.log('Codes',giftCardCodes)
  }

  useEffect(() => {
    const initialCheckBoxState = trackingData.map((val) => ({check: false, value: val}))
    setCheckBox(initialCheckBoxState)
  }, [trackingData])

  useEffect(() => {
    getTrackingCommit(statusFilter, daysFilter)
  }, [])

  useEffect(() => {
    const hasChecked = checkBox.some((check) => check.check === true)
    setShowDeleteBtn(hasChecked)
  }, [checkBox])

  // useEffect(() => {
  //   if(refresh == true){
  //   getTrackingCommit(statusFilter, daysFilter);
  //   setRefresh(false);
  //   }
  // }, [refresh]);

  // let rowIndex = 0;

  const toggleMenu = () => {
    setIsOpen(!isOpen)
    if (isOpen) {
      setToggleFilter('NONE')
    }
  }

  const handleStatusChange = (e) => {
    const selectedStatus = e.target.value
    setStatusFilter(selectedStatus)
    getTrackingCommit(selectedStatus, daysFilter)
  }
  const handleDaysChange = (e) => {
    const selectedDays = e.target.value
    setDaysFilter(selectedDays)
    getTrackingCommit(statusFilter, selectedDays)
  }

  const statusCondition = (val) => {
    var statusText = "";
    if (val == 0) {
      statusText = "Accepted";
    } else if (val == 1) {
      statusText = "Pending";
    } else if (val == 2) {
      statusText = "Rejected";
    } else if (val == 3) {
      statusText = "Package Lost";
    } else if (val == 11) {
      statusText = "Damaged";
    } else if (val == 12) {
      statusText = "Open Box";
    } else if (val == 13) {
      statusText = "Empty Box";
    } else if (val == 14) {
      statusText = "Empty Item";
    } else if (val == 15) {
      statusText = "Missing Item";
    } else if (val == 16) {
      statusText = "Wrong Product";
    }
    return statusText;
  };

  const csvData = [
    ["Tracking ID", "Deal ID", "Item Description", "Commitment ID", "Commited Qty", "Total Price", "Total Commission", "Grand Total","Status", "Scanned Date", "Tracking Date"],
    ...handleFilter().map(({ tracking_id, deal_no, deal_name, commitment_no, commited_qty, total_price, total_commission, grand_total, status,  updated_date , created_date  }) => [
      tracking_id, 
      deal_no,
      deal_name,
      commitment_no,
      commited_qty,
      total_price,
      total_commission,
      grand_total,
      statusCondition(status),
      updated_date,
      created_date
    ]),
  ];


  const getSerailCondition = (item) =>{
    if(item == 1){
      return(<h6 className="badge badge-success">Good</h6>)
    };
    if(item == 2){
      return(<h6 className="badge badge-danger">Damaged</h6>)
    }
    if(item == 3){
      return(<h6 className="badge badge-warning">Open Box</h6>)
    }
    if(item == 7){
      return(<h6 className="badge badge-danger">Wrong Product</h6>)
    }
  }



  const srnoBody = (item) => {
    return <span>{trackingData.indexOf(item) + 1}</span>
  }

  const checkboxBody = (item) => {
    var index = trackingData.indexOf(item)
    if (item.status == 1 || item.status == 2) {
      return (
        <>
          <div className='form-check form-check-sm form-check-custom form-check-solid text-center'>
            <input
              className='form-check-input widget-9-check'
              type='checkbox'
              // value={checkBox[index] ? checkBox[index].check : false}
              checked={checkBox[index] ? checkBox[index].check : false}
              onChange={(e) => {
                handleCheckChange(e, index, item)
              }}
            />
          </div>
        </>
      )
    }
    if (item.status == 0) {
      return (
        <>
          <div className=''>
            <i className='fa-solid fa-check-to-slot' style={{fontSize: '1.5rem'}}></i>
          </div>
        </>
      )
    }
  }

  const carrierBody = (item) => {
    return (
      <span className='text-dark fw-bold text-hover-primary fs-6'>
        <img src={item.store_logo} alt='' style={{width: '50px', height: 'auto'}} />
      </span>
    )
  }

  const imageBody = (item) => {
    return (
      <>
        <img src={item.deal_image} alt='' style={{width: '60px'}} />
      </>
    )
  }

  const trackingBody = (item) =>{
    const modalTitle = item?.tracking_id+' - '+ item?.deal_name;
    const GCdeal = (item?.deal_giftcard == 1) ? true : false;
    return(
      <>
      <div className='d-flex align-items-center'>
      <h6>{item.tracking_id}</h6>
        <button
        className='btn btn-sm'
        data-bs-toggle='modal'
        data-bs-target='#kt_modal_1'
        onClick={() => { 
          setTitle(modalTitle)
          setSerial(item?.serial_no)
          setGCQty(item?.qty)
          setGCDeal(GCdeal)
          if(item?.extradata_status == 1){
            setExtraDataDeal(true)
            setExtraData(item?.extradata)
          }else{
            setExtraDataDeal(false)
            setExtraData('')
          }
          setTrackingStatus(item?.status)
          setTrackingItemId(item.tracking_item_code)
          setExtraDataTrackingCode(item.tracking_code)
          if (item?.deal_giftcard == 1 ) {
            // const itemSerials = item.serial_no;
            const codes = [];
            item.serial_no.forEach(item => {
              codes.push({
                serial_id: item.id,
                tracking_item_id: item.tracking_item_id,
                code: item.gc_code || "",
              });
            });
            setGiftCardCodes(codes);
            
          }
        }}
      >
        <i className="fa-solid fa-circle-info fa-2x mb-2"></i>
      </button>
      </div>
      </>
    )
  }

  const otpBody = (item) => {
    return (
      <>
        {editId !== item.tracking_item_code && (
          <span className='text-dark fw-bold d-block mb-1 fs-6'>
            {item.otp ? item.otp : '---'}&nbsp;&nbsp;&nbsp;
            {item.status == 1 && (
              <span className='btn btn-icon btn-bg-light text-hover-primary btn-active-color-primary btn-sm me-1'>
                <button
                  onClick={() => {
                    setEditId(item.tracking_item_code)
                    setUpdatedOtp(item.otp)
                  }}
                  className='btn'
                >
                  <KTIcon iconName='pencil' className='fs-3' />
                </button>
              </span>
            )}
          </span>
        )}

        {editId == item.tracking_item_code && (
          <div className='w-200px'>
            <input
              type='text'
              className='form-control'
              value={updatedOtp}
              onChange={(e) => setUpdatedOtp(e.target.value.replace(/[^0-9]/g, ''))}
              placeholder='Enter OTP'
            />

            {errorMsg && (
              <p className='position-absolute text-danger fw-semibold' style={{marginTop: '-4px'}}>
                {errorMsg}
              </p>
            )}

            {btnLoading ? (
              <button className='btn btn-success btn-sm mt-5'>
                Wait... <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
              </button>
            ) : (
              <button
                onClick={updateOTP}
                className='btn btn-success btn-sm ml-10 mt-5'
                style={{marginRight: '15px'}}
              >
                Update
              </button>
            )}

            {!btnLoading && (
              <button
                className='btn btn-danger btn-sm mt-5'
                onClick={() => {
                  setEditId(null)
                  setUpdatedOtp(null)
                  setErrorMsg('')
                }}
              >
                Cancel
              </button>
            )}
          </div>
        )}
      </>
    )
  }

  const statusBody = (item) => {
    return (
      <>
        {item.status == 0 && <span className='badge badge-success fs-6 fw-bold'>Received</span>}
        {item.status == 1 && <span className='badge badge-warning fs-6 fw-bold'>Pending</span>}
        {item.status == 2 && <span className='badge badge-danger fs-6 fw-bold'>Rejected</span>}
        {item.status == 3 && <span className='badge badge-danger fs-6 fw-bold'>Package Lost</span>}
        {item.status == 5 && <span className='badge badge-info fs-6 fw-bold'>In Warehouse</span>}
        {item.status == 11 && <span className='badge badge-danger fs-6 fw-bold'>Damaged</span>}
        {item.status == 12 && <span className='badge badge-danger fs-6 fw-bold'>Open Box</span>}
        {item.status == 13 && <span className='badge badge-danger fs-6 fw-bold'>Empty Box</span>}
        {item.status == 14 && <span className='badge badge-danger fs-6 fw-bold'>Empty Item</span>}
        {item.status == 15 && <span className='badge badge-danger fs-6 fw-bold'>Item Missing</span>}
        {item.status == 16 && <span className='badge badge-danger fs-6 fw-bold'>Wrong Product</span>}
      </>
    )
  }


  const tableHeader = () => {
    return (
      <div className=''>
        <div className="row">
          <div className="col-lg-4 col-md-12">
            <h4 style={{marginTop: '10px'}}>Trackings</h4>
          </div>
          <div className="col-lg-8 col-md-12 d-lg-flex align-items-center justify-content-end mb-2">
            <div className='d-flex gap-3 align-items-center my-3'>
              <select
                id='statusFilter'
                className='form-select form-select-sm'
                value={statusFilter}
                onChange={handleStatusChange}
              >
                <option value='1'>Pending</option>
                <option value='0'>Accepted</option>
                <option value='3'>Warehouse</option>
                <option value='2'>Rejected</option>
                <option value='NOT_GOOD'>Damaged / Returned</option>
                <option value='All'>All</option>
              </select>
              <select
                id='daysFilter'
                className='form-select form-select-sm'
                value={daysFilter}
                onChange={handleDaysChange}
              >
                <option value='15'>15 Days</option>
                <option value='30'>30 Days</option>
                <option value='90'>3 Months</option>
                <option value='365'>365 Days</option>
                <option value='All'>All Data</option>
              </select>
            </div>

            <div className="filters-wrap ms-lg-2">
                {toggleFilter == 'SEARCH' && (
                  <div class="input-group">
                        <input
                          type='text'
                          className='form-control form-control-sm'
                          style={{width:225,borderTopRightRadius:0,borderBottomRightRadius:0}}
                          placeholder='Search here...'
                          value={searchQuery}
                          onChange={(e) => handleSingleSearch(e.target.value)}
                        />
                        <button
                          onClick={() => cancleSearch()}
                          className='btn btn-sm btn-secondary'
                          disabled={
                            searchCommitID === '' &&
                            searchDealID === '' &&
                            searchItemName === '' &&
                            searchTrackingNumber === '' &&
                            startDate === '' &&
                            endDate === ''
                          }
                        >
                          <i className='fa-solid fa-xmark fs-3'></i>
                        </button>
                  </div>
                )}

                {toggleFilter == 'DATE' && (
                  <div class="input-group">
                        <input
                          type='date'
                          className='form-control form-control-sm'
                          style={{width:100}}
                          placeholder='DD-MM-YYYY'
                          value={startDate}
                          onChange={(e) => setStartDate(e.target.value)}
                        />
                        <input
                          type='date'
                          className='form-control form-control-sm'
                          style={{width:100}}
                          placeholder='DD-MM-YYYY'
                          value={endDate}
                          onChange={(e) => setEndDate(e.target.value)}
                        />
                        <button
                          onClick={() => cancleSearch()}
                          className='btn btn-sm btn-secondary'
                          disabled={
                            searchCommitID === '' &&
                            searchDealID === '' &&
                            searchItemName === '' &&
                            startDate === '' &&
                            endDate === ''
                          }
                        >
                          <i className='fa-solid fa-xmark fs-3'></i>
                        </button>
                  </div>
                )}
                {toggleFilter == 'EXPORT' && (
                  <div className=''>
                    <div className='d-flex align-items-center'>
                      <div className='mx-2'>
                        <button className='btn btn-success text-dark'>
                          <CSVLink
                            className='downloadbtn'
                            filename='my-trackings.csv'
                            data={csvData}
                            style={{color: '#fff'}}
                          >
                            Export
                          </CSVLink>
                        </button>
                      </div>
                    </div>
                  </div>
                )}
            </div>

          </div>
        </div>

        <div className='d-flex align-items-center justify-content-between'>
          <div className='footer_btn3'>
            {deleteLoading ? (
              <button className='btn btn-danger' style={{marginRight: '15px'}}>
                Deleting...{' '}
                <span className='spinner-border spinner-border-sm align-middle ms-2 me-3'></span>
              </button>
            ) : (
              <>
                {showDeleteBtn && (
                  <button onClick={deleteTrack} className='btn btn-danger btn-lg me-3'>
                    <i className='fa-solid fa-trash'></i>&nbsp; Delete Tracking
                  </button>
                )}
              </>
            )}
            {/* <button className='btn btn-lg' onClick={() => setShowCreateAppModal(true)}>
              <i className='fa-solid fa-location-dot'></i>&nbsp; Tracking Import
            </button> */}
          </div>
        </div>
      </div>
    )
  }

  const filterButton = () => {
    return (
      <div className='floating-button-container'>
        {isOpen && (
          <div className={`menu-buttons ${isOpen ? 'show' : ''}`}>
            <button className='sub-button' onClick={() => setToggleFilter('EXPORT')}>
              <i className='fas fa-download'></i>
            </button>
            <button className='sub-button' onClick={() => setToggleFilter('DATE')}>
              <i className='fas fa-calendar-alt'></i>
            </button>
            <button className='sub-button' onClick={() => setToggleFilter('SEARCH')}>
              <i className='fas fa-search'></i>
            </button>
          </div>
        )}
        <button className='main-button' onClick={toggleMenu}>
          {isOpen ? <i className='fas fa-close'></i> : <i className='fas fa-sliders-h'></i>}
        </button>
      </div>
    )
  }

  const dataViewList = (items)=>{
      return(
        <div className="data-items">
          {
            items.map((item, idx) => (
              <DataViewItem item={item} idx={idx}/>
            ))
          }
        </div>
      )
    }
  
    const DataViewItem = ({item,idx}) =>{
      return(
        <Card key={idx} className="mb-3" style={{borderBottom:'2px solid green'}}>
            {/* <div className="p-d-flex p-ai-center mb-2"></div> */}
            <div className="row">
              <div className="col-3">
                <div class="mb-3">
                  <div className='card shadow card-rounded px-3 d-flex align-items-center justify-content-center'>
                    <img src={item.deal_image} style={{width:'80%',height:'auto'}} className='mt-3 mb-3' />
                  </div>
                  {/* {imageBody(item)} */}
                  </div>
              </div>
              <div className="col-9">
                <div className="d-flex align-items-center justify-content-between">
                  <h5 className="mb-2 mt-2">{trackingBody(item)}</h5>
                  <h5 className="mb-2 ">{checkboxBody(item)}</h5>
                </div>
                <p><strong>Quantity:</strong> {item.qty} | <strong className='ms-2'>Created:</strong> {item.created_date}</p>
              </div>
            </div>
            
            <div className='d-flex align-items-center justify-content-between'>
              <p><strong>Commit :</strong> {item.commitment_no} | <strong className='ms-2'>Deal :</strong> {item.deal_no}</p>
              {carrierBody(item)}
            </div>
            
            <div className="d-flex align-items-center justify-content-between">
              <div className="d-flex align-items-center"><span className='me-3'>OTP:</span><span>{otpBody(item)}</span></div>
               <div>{statusBody(item)}</div>
            </div>
          </Card>
      )
    }

  const columnStyle = {
    paddingLeft: 10,
    paddingRight: 10,
    paddingTop: 10,
    paddingBottom: 10,
    marginLeft: 10,
    marginRight: 10,
    width: '200px',
  }
  

  return (
    <div>
      <ImportTracking
        show={showCreateAppModal}
        handleClose={() => {
          setShowCreateAppModal(false)
        }}
        getTrackingCommit={getTrackingCommit}
        refreshCommitments={refreshComm == true ? true : false}
      />
      <ToastContainer />
      <div className=''>
      <div className='card shadow top-rounded'>
        <div className='card-body px-3 py-5'>
          {!isMobileDevice ? (
          <div className='trackings-table prime-table'>
            <DataTable
              value={handleFilter()}
              removableSort
              size='large'
              paginator
              rows={10}
              rowsPerPageOptions={[5, 10, 25, 50]}
              header={tableHeader}
              tableStyle={{
                minWidth: '60rem',
                alignItems: 'center',
                marginLeft: 'auto',
                fontSize: 15,
              }}
              scrollable
              scrollHeight='90vh'
              style={{minWidth: '50rem'}}
            >
              <Column body={checkboxBody} header='Action' style={columnStyle}></Column>
              <Column body={srnoBody} header='#' style={columnStyle}></Column>
              <Column body={carrierBody} header='Carrier' style={columnStyle}></Column>
              <Column field='deal_no' header='Deal ID' style={columnStyle}></Column>
              <Column body={imageBody} header='Image' style={columnStyle}></Column>
              <Column body={trackingBody} header='Tracking No.' sortable style={columnStyle}></Column>
              <Column body={otpBody} header='OTP' style={columnStyle}></Column>
              <Column field='qty' header='Qty' style={columnStyle}></Column>
              <Column field='commitment_no' header='Commit ID' style={columnStyle}></Column>
              <Column field='commited_qty' header='Commit Qty' style={columnStyle}></Column>
              <Column body={statusBody} header='Status' style={columnStyle}></Column>
              <Column
                field='created_date'
                header='Created Date'
                sortable
                style={columnStyle}
              ></Column>
            </DataTable>
          </div>
          ) : (
            <div className="card">
              <div className="card-header">{tableHeader()}</div>
              <div className="card-body px-0 py-1">
                <div className="mobile-card-container">
              {data.length === 0 ? (
                <p className="p-text-center ms-5">No Trackings Found..</p>
              ) : (
                <DataView 
                  value={handleFilter()}
                  listTemplate={dataViewList}
                  paginator
                  rows={10}
                  rowsPerPageOptions={[5, 10, 25, 50]}
                  paginatorTemplate='FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown'
                />
              )}
            </div>
              </div>
            </div>
          )}
        </div>
      </div>
      </div>

      <div className='modal fade' tabIndex={-1} id='kt_modal_1' ref={modalRef}>
          <div className='modal-dialog'>
            <div className='modal-content'>
              <div className='modal-header'>
                <h5 className='modal-title'>{title}</h5>
                <div
                  className='btn btn-icon btn-sm btn-active-light-primary ms-2'
                  data-bs-dismiss='modal'
                  aria-label='Close'
                >
                  <KTSVG
                    path='/media/icons/duotune/arrows/arr061.svg'
                    className='svg-icon svg-icon-2x'
                  />
                </div>
              </div>
              <div className='modal-body'>
                <div className='row'>
                  <div className='col-md-10'>
                    <label htmlFor="search"><h4><img src="https://cdn2.iconfinder.com/data/icons/cyber-monday-38/512/13_Product_barcode_upc_serial_number-512.png" alt="" width={'40px'} height={'45px'} />Serials</h4></label>
                    {/* <input type="search" name="search" id="search" className='form-control' placeholder='Search for a Serial' /> */}
                  </div>
                  <div className='col-md-11'>
                    <br />
                    <ul className="list-group">
                      {serial.length > 0 ? 
                      serial.filter(myitem => myitem.serial_no !== null)
                      .map((item,index) =>(
                          <li className="list-group-item  py-2" key={index}>
                        <div className="row align-items-center">
                          <div className="col-10">
                          <h6>{item?.serial_no}</h6>
                          </div>
                          <div className="col-2">
                          {getSerailCondition(item.serial_condition)}
                          </div>
                        </div>
                        </li>
                        )): (<p className='text-center'>There is no serial</p>)}
                    </ul>
                  </div>
                </div>
                <div className="gift_cards">
                  {(GCDeal == true) && (
                    <div>
                  {(trackingStatus == 0) ? (
                  <h6 className='my-3'>GiftCard Codes Accepted.</h6>
                ) : (
                  <>
                  <h5 className='my-3'>Gift Cards</h5>
                  <div className="row">
                  {GCQty > 0 && (() => {
                    const inputs = [];
                    for (let i = 0; i < GCQty; i++) {
                      inputs.push(
                        <div className="col-8 mb-2" key={i}>
                          <input
                            type="text"
                            name={`gc_code_${i}`}
                            placeholder="Gift Card Code"
                            className="form-control form-control-sm"
                            value={giftCardCodes[i]?.code || ""}
                            onChange={(e) =>
                              handleGCInputChange(
                                i,
                                e.target.value,
                                giftCardCodes[i]?.serial_id ?? null
                              )
                            }
                          />
                        </div>
                      );
                    }
                    return inputs;
                  })()}
                  </div>
                  <button className='btn btn-sm btn-primary' onClick={handleGCCodesSubmit}>Save</button>
                  </>
                  
                )}
                </div>
              )}

                </div>
                <div className="border-bottom my-2"></div>
                <div className="extradata_section">
                  {(extraDataDeal == true) && (
                  <>
                  <h5 className='my-3'>Order No/Tracking No</h5>
                  <div className="row">
                        <div className="col-8 mb-2">
                          <input
                            type="text"
                            placeholder="Order/Tracking No"
                            className="form-control form-control-sm"
                            value={extraData}
                            onChange={(e)=> setExtraData(e.target.value)}
                          />
                        </div>
                  </div>
                  <button className='btn btn-sm btn-primary' onClick={()=> handlExtraDataSubmit(extraDataTrackingCode)}>Save</button>
                  </> 
                )}

                </div>
              </div>
            </div>
          </div>
        </div>

      <div style={{zIndex: 999}}>{filterButton()}</div>
    </div>
  )
}

export default TrackingManagement
